/* 3.10.2026 (Aleksandra, UX audit "strona tortu", phone + desktop) - the product page of the new batida.pl, all products:
   1. "Napis na torcie" is a text field right under the size ("+ 10,00 zł · opcjonalnie"), not a switch among the add-ons.
      Typing switches the existing (now hidden) inscription switch on, an empty field switches it off - so the cart, the
      inscription add-on and FoodSoft get exactly what they got before (assets/batida-personalizacja-v2.js does the work).
   2. Phones: the add-ons fold into one row "+ Dodatki do tortu (opcjonalnie) · 4"; a tap opens the same switches.
      (Which add-ons are there - max 4 - is decided in snippets/batida-personalizacja-v2.liquid.)
   3. Delivery in two lines instead of three big cards: "Odbiór w cukierni - za darmo, najbliższy 05.10" and
      "Dostawa po Warszawie - od 200 zł, za darmo od 500 zł"; the DPD line only for products that ship. The dates are read
      from the original cards (kept hidden - Batida Connect / zapiet-availability.js fill them).
   4. Desktop: the "Pasuje do tego" carousel moves to the left column, under the coffee pairing, so the columns end level.
   Texts: window.__v7pdp (sections/header.liquid, locale keys batida.v7pdp.*). Revert: remove the script tag in
   sections/header.liquid; the page falls back to the old layout (the CSS only acts on classes this script sets). */
(function () {
  var H = document.documentElement;
  if (!H.classList.contains('v7') || window.__v7pdpLoaded) return;
  window.__v7pdpLoaded = true;
  var T = window.__v7pdp || {};
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function money(gr) { var a = (gr || 0) / 100; return (a % 1 ? a.toFixed(2).replace('.', ',') : String(a)) + ' zł'; }
  function icon(n, s) { return window.batidaIcon ? window.batidaIcon(n, s || 22) : ''; }

  // ---------- 1. inscription as a field under the size ----------
  function napisInline() {
    var card = document.querySelector('batida-personalizacja[data-perso-v2]');
    var inp = document.getElementById('batida-napis-text');
    var row = card && card.querySelector('.batida-perso-row[data-napis-row]');
    if (!card || !row) return;
    var title = ((row.querySelector('.batida-perso-title') || {}).textContent || '').trim();
    var price = ((row.querySelector('.batida-perso-price-col') || {}).textContent || '').replace(/\s+/g, ' ').trim();
    if (card.classList.contains('has-napis-inline')) {   // later runs: the switch's title may have been translated since
      var b0 = document.querySelector('.v7-napis__l b'); if (b0 && title && b0.textContent !== title) b0.textContent = title;
      return;
    }
    if (!inp) return;
    var btn = row.querySelector('.batida-perso-toggle');
    if (!btn) return;
    var box = document.createElement('div');
    box.className = 'v7-napis';
    box.setAttribute('data-perso-v2', '');   // batida-personalizacja-v2.js removes stray inscription inputs outside [data-perso-v2]
    box.innerHTML = '<label class="v7-napis__l" for="batida-napis-text"><b>' + esc(title) + '</b><span>' + esc(price) + ' · ' + esc(T.optional || 'opcjonalnie') + '</span></label>';
    box.appendChild(inp);
    var sel = document.querySelector('.product__block__variants .form__selectors');
    var lbl = document.querySelector('.batida-section-label--perso');
    var anchor = sel && sel.offsetParent !== null ? sel : null;
    if (anchor) anchor.parentNode.insertBefore(box, anchor.nextSibling);
    else (lbl || card).parentNode.insertBefore(box, lbl || card);
    card.classList.add('has-napis-inline');
    // 3.10 (Aleksandra, version A): under the field a green "✓ Napis zostanie dodany do tortu · +10,00 zł" + "11/30" while
    // something is typed; the field gets a black border; cleared = both gone. No extra button.
    var max = +inp.getAttribute('maxlength') || 30;
    var ok = document.createElement('div');
    ok.className = 'v7-napis__ok';
    ok.hidden = true;
    ok.setAttribute('aria-live', 'polite');
    ok.innerHTML = '<span class="v7-napis__msg"></span><span class="v7-napis__cnt"></span>';
    box.appendChild(ok);
    var priceShort = price.replace(/^\+\s*/, '+');
    function status() {
      var v = inp.value, filled = !!v.trim();
      box.classList.toggle('is-filled', filled);
      ok.hidden = !filled;
      if (filled) {
        ok.firstChild.textContent = '✓ ' + (T.napisAdded || 'Napis zostanie dodany do tortu') + (priceShort ? ' · ' + priceShort : '');
        ok.lastChild.textContent = v.length + '/' + max;
      }
    }
    function sync() {
      var want = !!inp.value.trim(), on = btn.getAttribute('aria-pressed') === 'true';
      if (want !== on) btn.click();   // the card's own click handler adds/removes the inscription exactly as the switch did
      status();
    }
    status();
    inp.addEventListener('input', sync);
    inp.addEventListener('change', sync);
  }

  // ---------- 2. phones: add-ons behind one row ----------
  function addonsFold() {
    var card = document.querySelector('batida-personalizacja[data-perso-v2]');
    if (!card || card.__v7fold) return;
    card.__v7fold = true;
    var rows = card.querySelectorAll('.batida-perso-row:not([data-napis-row])');
    var lbl = document.querySelector('.batida-section-label--perso');
    if (!rows.length) {   // only the inscription was there (now the field above): no empty card
      card.classList.add('v7-addons-none');
      if (lbl) lbl.classList.add('v7-addons-none');
      return;
    }
    var cake = !!card.querySelector('.batida-perso-row[data-napis-row]');
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'v7-addons-btn';
    b.setAttribute('aria-expanded', 'false');
    b.innerHTML = '<span class="v7-addons-btn__t">+ ' + esc(cake ? (T.addonsCake || 'Dodatki do tortu') : (T.addons || 'Dodatki')) + ' <small>(' + esc(T.optional || 'opcjonalnie') + ') · ' + rows.length + '</small></span><span class="v7-addons-btn__c" aria-hidden="true">▾</span>';
    card.parentNode.insertBefore(b, card);
    card.classList.add('v7-addons-fold');
    b.addEventListener('click', function () {
      var open = card.classList.toggle('is-open');
      b.classList.toggle('is-open', open);
      b.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  // ---------- 3. delivery in two lines ----------
  // 8.10 (Pat, QA sweep): the delivery lines (and the "Dostawa od 200 zł" line under the price) looked clickable and did nothing
  // (Clarity dead clicks). They open the "Dostawa i odbiór" tab (sections/batida-v7-details.liquid, tab id ...-dost) and scroll to it.
  function deliveryTab() { return document.querySelector('[role="tab"][id^="v7t-"][id$="-dost"]'); }
  function openDelivery() {
    var t = deliveryTab(); if (!t) return false;
    if (t.getAttribute('aria-selected') !== 'true') t.click();
    var p = document.getElementById(t.getAttribute('aria-controls'));
    var target = (p && !p.hidden ? t.closest('.v7-tabs') : null) || t;
    try { target.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (e) { target.scrollIntoView(); }
    return true;
  }
  function deliveryLinks() {
    if (document.__v7dgo) return; document.__v7dgo = true;
    var sel = '.v7-dline--go, .v7-price-min[data-min200-line]';
    document.addEventListener('click', function (e) { var el = e.target.closest && e.target.closest(sel); if (el && !e.target.closest('a') && openDelivery()) e.preventDefault(); });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var el = e.target.closest && e.target.closest(sel); if (el && openDelivery()) e.preventDefault();
    });
    var pm = document.querySelector('.v7-price-min[data-min200-line]');
    if (pm && deliveryTab()) { pm.setAttribute('role', 'button'); pm.tabIndex = 0; pm.classList.add('v7-dline--go'); }
  }
  function deliveryLines() {
    var bph = document.querySelector('.product__block__zapiet-availability.bph');
    if (!bph || bph.__v7lines || !bph.querySelector('.bph-pick--delivery')) return;   // b2b markup has no delivery row
    bph.__v7lines = true;
    var FD = window.batidaFD || {};
    var box = document.createElement('div');
    box.className = 'v7-dlines';
    bph.parentNode.insertBefore(box, bph);
    bph.classList.add('is-v7-hidden');
    function dateOf(sel) {
      var d = bph.querySelector(sel);
      var t = d ? d.textContent.replace(/\s+/g, ' ').trim() : '';
      t = t.replace(/^(od|from|ab|dès|від)\s+/i, '');
      return /\d/.test(t) && t.length < 20 ? t : '';
    }
    function render() {
      var go = deliveryTab() ? ' class="v7-dline v7-dline--go" role="button" tabindex="0"' : ' class="v7-dline"';   // 8.10 (Pat, QA sweep): tappable when the "Dostawa i odbiór" tab exists
      var pick = bph.querySelector('.bph-pick:not(.bph-pick--delivery):not(.bph-pick--ship)');
      var del = bph.querySelector('.bph-pick--delivery'), ship = bph.querySelector('.bph-pick--ship');
      var pd = dateOf('.bph-pick:not(.bph-pick--delivery):not(.bph-pick--ship) .bph-date');
      var sd = dateOf('.bph-pick--ship .bph-date');
      var html = '';
      if (pick) html += '<p' + go + '><span class="v7-dline__i">' + icon('cukiernia') + '</span><span>' + esc(T.pickup || 'Odbiór w cukierni - za darmo') + (pd ? ', ' + esc(T.nearestM || 'najbliższy') + ' <b>' + esc(pd) + '</b>' : '') + '</span></p>';
      if (del && !del.classList.contains('bph-pick--off')) html += '<p' + go + '><span class="v7-dline__i">' + icon('dostawa') + '</span><span>' + esc((T.delivery || 'Dostawa po Warszawie - od [min], za darmo od [free]').replace('[min]', money(FD.min || 20000)).replace('[free]', money(FD.threshold || 50000))) + '</span></p>';
      if (ship && !ship.classList.contains('bph-pick--off')) html += '<p' + go + '><span class="v7-dline__i">' + icon('wysylka') + '</span><span>' + esc(T.ship || 'Wysyłka kurierem DPD Foods') + (sd ? ', ' + esc(T.nearestF || 'najbliższa') + ' <b>' + esc(sd) + '</b>' : '') + '</span></p>';
      // 3.10 (Aleksandra): packaging, only for cakes / monoporcje / crumble cookies / artistic cakes (T.pack set in header.liquid)
      if (T.pack && (T.pack[0] || T.pack[1])) html += '<p class="v7-dline v7-dline--pack"><span class="v7-dline__i"><svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round" aria-hidden="true"><path d="M3 7.5L12 3l9 4.5v9L12 21l-9-4.5z"/><path d="M3 7.5L12 12l9-4.5M12 12v9"/><path d="M7.5 5.2l9 4.5"/></svg></span><span>' + (T.pack[0] ? '<b>' + esc(T.pack[0]) + '</b> - ' + esc(T.pack[1] || '') : esc(T.pack[1] || '')) + '</span></p>';
      if (box.innerHTML !== html) box.innerHTML = html;
    }
    render();
    var t = 0;
    try { new MutationObserver(function () { clearTimeout(t); t = setTimeout(render, 60); }).observe(bph, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['class'] }); } catch (e) {}
  }

  // ---------- 4. desktop: "Pasuje do tego" under the coffee pairing ----------
  function pairsLeft() {
    var pm = document.querySelector('.v7pm[data-v7pm]');
    var slot = document.querySelector('.product__media__wrapper .v7-details-slot');
    if (!pm || !slot || pm.__v7left) return;
    pm.__v7left = true;
    var home = pm.parentNode, next = pm.nextSibling;
    function apply() {
      var desk = getComputedStyle(slot).display !== 'none';
      if (desk && pm.parentNode !== slot.parentNode) { slot.parentNode.insertBefore(pm, slot.nextSibling); pm.classList.add('v7pm--left'); }
      else if (!desk && pm.parentNode !== home) { home.insertBefore(pm, next && next.parentNode === home ? next : null); pm.classList.remove('v7pm--left'); }
    }
    apply();
    var rt = 0;
    window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(apply, 150); });
    // 10.10: the slot is server-rendered but stays [hidden] until batida-v7-details-slot.js has moved the details in (when the
    // buy box is much taller than the gallery), which can happen after this first call: then the block stayed in the right
    // column for good. Follow the slot instead (idempotent: apply() only moves when the block is not yet where it belongs).
    try { new MutationObserver(apply).observe(slot, { attributes: true, attributeFilter: ['hidden'] }); } catch (e) {}
  }

  function run() {
    if (!document.body || !document.body.classList.contains('template-product')) return;
    [napisInline, addonsFold, deliveryLines, deliveryLinks, pairsLeft].forEach(function (f) { try { f(); } catch (e) {} });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  // the add-ons card, the inscription input and the carousel are server-rendered, but some blocks are placed by scripts
  // after load (label glue, details slot) - run again a few times; every step runs once
  [300, 900, 2000].forEach(function (ms) { setTimeout(run, ms); });
  window.addEventListener('load', run);   // 10.10: also once when everything is loaded (bounded: pairsLeft() then follows the slot itself)
})();
